// PROGRESS:
//
// - ⌛ note_story_from_author_subscription [TODO]
// - ⌛ note_story_from_hashtag_subscription [TODO]
// - ✅ note_user_subscriber
// - ✅ note_user_subscription_accept
// - ✅ note_story_like
// - ✅ note_story_comment
// - ✅ note_comment_like
// - ✅ note_comment_reply
// - ✅ note_comment_mention

const pushNotifications = [
  require("./note_story_from_author_subscription"),
  require("./note_story_from_hashtag_subscription"),
  require("./note_user_subscriber"),
  require("./note_user_subscription_accept"),
  require("./note_story_like"),
  require("./note_story_comment"),
  require("./note_comment_like"),
  require("./note_comment_reply"),
  require("./note_comment_mention"),
];

const accountNotifications = pushNotifications.filter((n) => n.count_alias);

function getNotificationConfig(id, accountOnly) {
  if (accountOnly) {
    for (let accountNotification of accountNotifications)
      if (accountNotification.key === id) return accountNotification;
  } else {
    for (let pushNotification of pushNotifications)
      if (pushNotification.key === id) return pushNotification;
  }
}

const notifications = {
  push: pushNotifications,
  account: accountNotifications,
  get: getNotificationConfig,
};

module.exports = notifications;
